// extracted by mini-css-extract-plugin
module.exports = {"itemDescription":"RenderItemDescription_itemDescription__5DHqo"};